import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Route } from 'react-router-dom';

const ModalConcordanciaGerenciar = ({ visible, setDialogConcordar, setHomePainel, setPainelState, callRequestPainelPermicao, painel, usuario}) => {
    const dialogName = 'dialogConcordar';

    const mudarVisualizacao = () => {
        setDialogConcordar(false);
        setHomePainel(true);
    }

    const footer = (
        <div className="p-d-flex p-jc-between">
            <Route render={(props) => (
                <Button className="p-button-danger" label="DISCORDO" icon="pi pi-times" onClick={() => {
                    props.history.goBack();
                }} />
            )} />
            <Button label="CONCORDO" icon="pi pi-check" onClick={async () => {
                let emailGestor = painel.proprietario;
                let emailEditor = usuario.email;
                try {
                    const painelAtualizado = await callRequestPainelPermicao(emailGestor, emailEditor);
                    setPainelState(painelAtualizado);
                    mudarVisualizacao();
                } catch (error) {
                    console.error('Erro ao obter permissão do painel:', error);
                }
            }} />
        </div>
    );

    return (
        <Dialog closable={false} header="Você deseja confirmar o gerenciamento deste painel?" footer={footer} visible={visible} style={{ width: '85vw' }} modal onHide={() => this.onHide(dialogName)} >
            <ol style={{ lineHeight: '1.5rem', listStylePosition: 'inside', display: 'flex', flexDirection: 'column' }}>
                <li>Este painel poderá ser modificado até <b style={{ color: 'red' }}>{new Date(painel.terminoAplicacao).toLocaleString()}</b></li>
                <li>Ao prosseguir, você concorda em participar do processo avaliativo.<br /></li>
                <li>Gerencie cada dimensão avaliativa deste painel, cadastrando tópicos (fragilidades e potencialidades) detectadas.<br /></li>
                <li>O painel suporta edição simultânea — cada tópico pode ser editado por um usuário de cada vez.<br /></li>
                <li>Para cada potencialidade ou fragilidade cadastrada, especialmente sobre fragilidades, cadastre ações de melhorias.<br /></li>
                <li>O último acesso a este painel foi em: <b style={{ color: 'red' }}>{new Date(painel.ultimoAcesso.dataHora).toLocaleString()}</b>, 
                pelo usuário <b style={{ color: 'red' }}>{painel.ultimoAcesso.email}</b></li>
            </ol>
        </Dialog>
    );
};

export default ModalConcordanciaGerenciar;
